<template>
<div>
  <!-- 이벤트 등급 설정 -->
  <div class="mr-b30">
    <el-row class="title-bar" type="flex" justify="space-between">
      <div class="vertical-center-box">
        <div class="title-h3">이벤트 등급 설정</div>
        <div class="setting-addel mr-l15">
          <el-button size="mini" @click="addEventLevel"><i class="fas fa-plus"></i></el-button>
          <el-button size="mini" :disabled="!isEventDelete" @click="deleteEventLevel"><i class="fas fa-minus"></i></el-button>
        </div>
      </div>
      <div>
        <el-button size="small" type="primary" @click="setDefaultValue('EVENT')">기본설정적용</el-button>
      </div>
    </el-row>
    <el-table-wrapper slot="body" border row-class-name="c-dblclick" :column-default="columnDefault" :data="eventlevelList" :columns="eventLevelColumns" @selection-change="eventChangeSelection" :pagination="false" style="width:100%;" @row-dblclick="onEditEventClickRow">
      <template slot-scope="scope" slot="level-background">
        <div class="vertical-center-box">
          <div class="mr-r4" :style="getFieldColor('20px', '20px', scope.row.eventlevelColorBg, true)">
          </div>
          {{scope.row.eventlevelColorBg}}
        </div>
      </template>
      <template slot-scope="scope" slot="level-font">
        <div class="vertical-center-box">
          <div class="mr-r4" :style="getFieldColor('20px', '20px', scope.row.eventlevelColorText, true)">
          </div>
          {{scope.row.eventlevelColorText}}
        </div>
      </template>
      <template slot-scope="scope" slot="preview-color">
        <div :style="getFieldColor('60px', '20px', scope.row.eventlevelColorBg, false)">
          <p><font :color="scope.row.eventlevelColorText">{{scope.row.eventlevelColorText}}</font></p>
        </div>
      </template>
    </el-table-wrapper>
  </div>
  <!-- 장애티켓 등급 설정 -->
  <el-row type="flex" class="title-bar" justify="space-between">
    <div class="title-h3">장애티켓 등급설정</div>
  </el-row>
  <el-row :gutter="10">
    <el-col :span="12">
      <el-row class="title-bar" type="flex" justify="space-between">
        <div class="vertical-center-box">
          <div class="title-h4">긴급도 설정</div>
          <div class="setting-addel mr-l15">
            <el-button size="mini" @click="addUrgency()"><i class="fas fa-plus"></i></el-button>
            <el-button size="mini" :disabled="!isUrgencyDelete" @click="deleteUrgency()"><i class="fas fa-minus"></i></el-button>
          </div>
        </div>
        <div>
          <el-button size="small" type="primary" @click="setDefaultValue('URGENCY')">기본설정적용</el-button>
        </div>
      </el-row>
      <el-table-wrapper border :data="urgencyList" row-class-name="c-dblclick" :column-default="columnDefault" :columns="urgencyColumns" :pagination="false" style="width:100%;" @row-dblclick="onEditUrgencyClickRow" @selection-change="urgencyChangeSelection" >
      </el-table-wrapper>
    </el-col>
    <el-col :span="12">
      <el-row class="title-bar" type="flex" justify="space-between">
        <div class="vertical-center-box">
          <div class="title-h4">영향도 설정</div>
          <div class="setting-addel mr-l15">
            <el-button size="mini" @click="addImpact()"><i class="fas fa-plus"></i></el-button>
            <el-button size="mini" :disabled="!isImpactDelete" @click="deleteImpact()"><i class="fas fa-minus"></i></el-button>
          </div>
        </div>
        <div>
          <el-button size="small" type="primary" @click="setDefaultValue('IMPACT')">기본설정적용</el-button>
        </div>
      </el-row>
      <el-table-wrapper border :data="impactList" row-class-name="c-dblclick" :column-default="columnDefault" :columns="impactColumns" :pagination="false" style="width:100%;" @row-dblclick="onEditImpactClickRow" @selection-change="impactChangeSelection" >
      </el-table-wrapper>
    </el-col>
  </el-row>
  <w-eventlevel-popup ref="eventlevelPopup" @reload-data="loadData" :popup-type="eventLevelPopupType" :editRow="editRow" :eventlevelList="eventlevelList"/>
  <w-urgency-popup ref="urgencyPopup" @reload-data="loadData" :popup-type="urgencyPopupType" :editRow="editRow" :urgencyList="urgencyList"/>
  <w-impact-popup ref="impactPopup" @reload-data="loadData" :popup-type="impactPopupType" :editRow="editRow" :impactList="impactList"/>
</div>
</template>

<script>
import eventlevelAPI from '@/api/model/eventlevel';
import operationSettingsAPI from '@/api/settings/common/operation-settings';
import { getValueAfterCheckEmpty } from '@/utils/string';
import { columnDefault } from '@/constants/table';
import msgUtil from '@/utils/message';
import sortBy from 'lodash/sortBy';
import isNil from 'lodash/isNil';
import cloneDeep from 'lodash/cloneDeep';
import WColorField from '@/components/form/ColorField';
import WEventlevelPopup from './popup/EventlevelPopup';
import WUrgencyPopup from './popup/UrgencyPopup';
import WImpactPopup from './popup/ImpactPopup';

const defaultValue = { URGENCY: '긴급도', IMPACT: '영향도', EVENT: '이벤트' };

export default {
  name: 'WEventLevel',
  props: {
    activeTab: {
      type: String,
    },
  },
  components: {
    WEventlevelPopup,
    WUrgencyPopup,
    WImpactPopup,
    WColorField,
  },
  data() {
    return {
      columnDefault,
      eventlevelList: [],
      editRow: {},
      urgencyList: [],
      impactList: null,
      eventLevelPopupType: null,
      urgencyPopupType: null,
      impactPopupType: null,
      isEventDelete: false,
      isUrgencyDelete: false,
      isImpactDelete: false,
      changeEventLevelList: [],
      changeUrgencyList: [],
      changeImpactList: [],
      eventLevelColumns: [
        {
          align: 'center',
          type: 'selection',
        },
        {
          prop: 'orderbyIndex',
          label: '장애등급',
          sortable: true,
          formatter: this.getTableValueAfterCheckEmpty,
        },
        {
          prop: 'eventlevelId',
          label: '장애 코드',
          sortable: true,
          formatter: this.getTableValueAfterCheckEmpty,
        },
        {
          prop: 'eventlevelName',
          label: '장애등급 이름',
          sortable: true,
          formatter: this.getTableValueAfterCheckEmpty,
        },
        {
          prop: 'eventlevelColorBg',
          label: '배경 색상',
          scopedSlot: 'level-background',
          sortable: true,
          formatter: this.getTableValueAfterCheckEmpty,
        },
        {
          prop: 'eventlevelColorText',
          label: '폰트 색상',
          scopedSlot: 'level-font',
          sortable: true,
          formatter: this.getTableValueAfterCheckEmpty,
        },
        {
          label: '미리보기',
          scopedSlot: 'preview-color',
          sortable: true,
          formatter: this.getTableValueAfterCheckEmpty,
        },
      ],
      urgencyColumns: [
        {
          align: 'center',
          type: 'selection',
        },
        {
          prop: 'urgencyId',
          width: 100,
          label: 'ID',
          sortable: true,
          searchable: true,
          formatter: this.getTableValueAfterCheckEmpty,
        },
        {
          prop: 'urgencyName',
          label: '이름',
          sortable: true,
          searchable: true,
          formatter: this.getTableValueAfterCheckEmpty,
        },
        {
          prop: 'urgencyDesc',
          label: '설명',
          sortable: true,
          searchable: true,
          formatter: this.getTableValueAfterCheckEmpty,
        },
      ],
      impactColumns: [
        {
          align: 'center',
          type: 'selection',
        },
        {
          prop: 'impactId',
          width: 100,
          label: 'ID',
          sortable: true,
          searchable: true,
          formatter: this.getTableValueAfterCheckEmpty,
        },
        {
          prop: 'impactName',
          label: '이름',
          sortable: true,
          searchable: true,
          formatter: this.getTableValueAfterCheckEmpty,
        },
        {
          prop: 'impactDesc',
          label: '설명',
          sortable: true,
          searchable: true,
          formatter: this.getTableValueAfterCheckEmpty,
        },
      ],
    };
  },
  watch: {
    activeTab: {
      handler() {
        this.loadData();
      },
      immediate: true,
    },
    // changeEventLevelList: {
    //   handler() {
    //     if (this.changeEventLevelList.length > 0) {
    //       this.isEventDelete = true;
    //     } else {
    //       this.isEventDelete = false;
    //     }
    //   },
    //   immeditate: true,
    // },
    // changeUrgencyList: {
    //   handler() {
    //     if (this.changeUrgencyList.length > 0) {
    //       this.isUrgencyDelete = true;
    //     } else {
    //       this.isUrgencyDelete = false;
    //     }
    //   },
    //   immeditate: true,
    // },
    // changeImpactList: {
    //   handler() {
    //     if (this.changeImpactList.length > 0) {
    //       this.isImpactDelete = true;
    //     } else {
    //       this.isImpactDelete = false;
    //     }
    //   },
    //   immeditate: true,
    // },
  },
  methods: {
    loadData() {
      if (this.activeTab === this.$options.name) {
        eventlevelAPI.getList().then((response) => {
          const rslt = response.data.data;
          const eventList = sortBy(rslt, [(o) => o.orderbyIndex]);
          this.eventlevelList = eventList;
        });
        operationSettingsAPI.getUrgencyList().then((response) => {
          this.urgencyList = response.data.data;
        });
        operationSettingsAPI.getImpactList().then((response) => {
          this.impactList = response.data.data;
        });
      }
    },
    /**
     * 이벤트 등급의 배경 색상, 폰트 색상, 미리보기 스타일을 지정한다.
     * @author yelim
     */
    getFieldColor(width, height, colorValue, isBorder) {
      if (isBorder) {
        return `width:${width}; height:${height}; background:${colorValue}; display: inline-block; border: 1px solid #bcbcbc;`;
      }
      return `width:${width}; height:${height}; background:${colorValue}; display: inline-block;`;
    },
    onEditEventClickRow(row) {
      this.editRow = cloneDeep(row);
      this.eventLevelPopupType = 'EDIT';
      this.$refs.eventlevelPopup.open();
    },
    addEventLevel() {
      this.editRow = {};
      this.eventLevelPopupType = 'ADD';
      this.$refs.eventlevelPopup.open();
    },
    deleteEventLevel() {
      if (!isNil(this.changeEventLevelList)) {
        const action = msgUtil.action.DELETE;
        this.$confirm(...msgUtil.getBasicConfirmData(action)).then(() => {
          const target = '이벤트 등급';
          eventlevelAPI.deleteEventlevels(this.changeEventLevelList).then((response) => {
            if (response.data.success) {
              this.$message(msgUtil.getResultMsgData(action, target, true));
              this.loadData();
            } else {
              this.$message(msgUtil.getResultMsgData(action, target, false));
            }
          }).catch(() => {
            this.$message(msgUtil.getResultMsgData(action, target, false));
          });
        });
      }
    },
    onEditUrgencyClickRow(row) {
      this.editRow = cloneDeep(row);
      this.urgencyPopupType = 'EDIT';
      this.$refs.urgencyPopup.open();
    },
    addUrgency() {
      this.editRow = {};
      this.urgencyPopupType = 'ADD';
      this.$refs.urgencyPopup.open();
    },
    deleteUrgency() {
      if (!isNil(this.changeUrgencyList)) {
        const action = msgUtil.action.DELETE;
        this.$confirm(...msgUtil.getBasicConfirmData(action)).then(() => {
          const target = '긴급도';
          operationSettingsAPI.deleteItsmUrgency(this.changeUrgencyList).then((response) => {
            if (response.data.success) {
              this.$message(msgUtil.getResultMsgData(action, target, true));
              this.loadData();
            } else {
              this.$message(msgUtil.getResultMsgData(action, target, false));
            }
          }).catch(() => {
            this.$message(msgUtil.getResultMsgData(action, target, false));
          });
        });
      }
    },
    onEditImpactClickRow(row) {
      this.editRow = cloneDeep(row);
      this.impactPopupType = 'EDIT';
      this.$refs.impactPopup.open();
    },
    addImpact() {
      this.editRow = {};
      this.impactPopupType = 'ADD';
      this.$refs.impactPopup.open();
    },
    deleteImpact() {
      if (!isNil(this.changeImpactList)) {
        const action = msgUtil.action.DELETE;
        this.$confirm(...msgUtil.getBasicConfirmData(action)).then(() => {
          const target = '영향도';
          operationSettingsAPI.deleteItsmImpact(this.changeImpactList).then((response) => {
            if (response.data.success) {
              this.$message(msgUtil.getResultMsgData(action, target, true));
              this.loadData();
            } else {
              this.$message(msgUtil.getResultMsgData(action, target, false));
            }
          }).catch(() => {
            this.$message(msgUtil.getResultMsgData(action, target, false));
          });
        });
      }
    },
    eventChangeSelection(selectVal) {
      this.changeEventLevelList = selectVal;
      if (selectVal.length > 0) {
        this.isEventDelete = true;
      } else {
        this.isEventDelete = false;
      }
    },
    urgencyChangeSelection(selectVal) {
      this.changeUrgencyList = selectVal;
      if (selectVal.length > 0) {
        this.isUrgencyDelete = true;
      } else {
        this.isUrgencyDelete = false;
      }
    },
    impactChangeSelection(selectVal) {
      this.changeImpactList = selectVal;
      if (selectVal.length > 0) {
        this.isImpactDelete = true;
      } else {
        this.isImpactDelete = false;
      }
    },
    getTableValueAfterCheckEmpty(row, column, value) {
      return getValueAfterCheckEmpty(value);
    },
    setDefaultValue(defalutName) {
      const action = msgUtil.action.APPLY;
      const targetDefaultName = `${defaultValue[defalutName]} 기본 설정 적용`;
      this.$confirm(...msgUtil.getBasicConfirmData(action)).then(() => {
        operationSettingsAPI.setBasicInfo({ basicName: defalutName }).then((response) => {
          if (response.data.success) {
            this.loadData();
            this.$message(msgUtil.getResultMsgData(action, targetDefaultName, true));
          } else {
            this.$message(msgUtil.getResultMsgData(action, targetDefaultName, false));
          }
        }).catch(() => {
          this.$message(msgUtil.getResultMsgData(action, targetDefaultName, false));
        });
      });
    },
  },
};
</script>

<style>
</style>



// WEBPACK FOOTER //
// src/views/settings/operation/EventAlarmSettings/EventSettings/EventLevel.vue